import styled from "styled-components";

export const SPage = styled.div`
  width: 100vw;

  display: flex;
  justify-content: center;
  align-items: center;

  color: #3c4257;
  background-color: #f7fafc;

  @media (min-width: 1024px) {
    height: 100vh;
  }
`;

export const SHeader = styled.div`
  font-size: 24px;
  text-align: center;
  margin: 24px 0;
`;

export const SDescription = styled.p`
  font-size: 14px;
  text-align: center;
`;

export const SContainer = styled.div`
  width: 100%;
  height: 100%;
  background-color: white;
  border-radius: 4px;
  box-sizing: border-box;
  box-shadow: 0 15px 35px 0 rgb(60 66 87 / 8%), 0 5px 15px 0 rgb(0 0 0 / 12%);

  @media (min-width: 1024px) {
    width: 440px;
    height: fit-content;
  }
`;

export const SHeaderContainer = styled.div`
  width: 100%;
  background: #031133;

  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 0;

  @media (min-width: 1024px) {
    border-radius: 4px 4px 0 0;
  }
`;

export const SBodyContainer = styled.div`
  width: 100%;
  background: "#031133";
  padding: 0 40px 40px;

  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const SImage = styled.img`
  width: 165px;
  margin: 24px;
`;

export const SQRContainer = styled.div`
  width: 164px;
  height: 164px;

  margin: 24px 0;

  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid lightgray;
  border-radius: 4px;
`;

export const SStoreButton = styled.img`
  display: inline;
  height: 50px;
  margin: 10px;
`;
